import { request } from '@blade/common';
// 获取设备树
export const getDeviceTreeApi = (data = {}) => request.post('/api/iot-device-management/api/v2/iot/devices/tree', data);
// 获取人像库
export const getLibPortaitListApi = (data = {}) => request.post('/api/portrait-management/api/v1/portraitlib/list', data);
